import * as utils from './utils';
import * as yup from 'yup';
import { Activite } from '../entities';

export const schemaActivite = yup.object<Partial<Activite>>({
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    trigger_suivi: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    ville: yup.string().nullable(),
    covid: yup.string().nullable(),
    covid_description: yup.string().nullable(),
    alerte: yup.string().nullable(),
    temps_avance_animateur: yup.string().nullable(),
    ratio_groupe: yup.string().nullable(),
    public_cible: yup.string().nullable(),
    locaux: yup.string().nullable(),
    description: yup.string().nullable(),
    fk_id_fournisseur: yup.number().nullable(),
    fk_id_image_principale: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    minimum_facturable_nombre: yup
        .number()
        .nullable()
        .transform(utils.emptyStringToNullTransform)
        .integer('Ce champ doit contenir un nombre entier')
        .moreThan(0, 'Doit être supérieur à 0'),
    minimum_facturable_type: yup.string().nullable(),
    minimum_facturable_texte: yup.string().nullable(),
    name: yup.string().required('Ce champ est requis'),
    notes: yup.string().nullable(),
    periode_ouverture: yup.string().nullable(),
    tarifs_estimes: yup.string().nullable(),
    pct_commission_defaut: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    fk_id_type_activite: yup.number().required("Le type d'activité est obligatoire"),
    actif: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
    taxable: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
    public: yup.boolean().nullable().default(false).transform(utils.nullBoolToFalse),
    max_participants: yup
        .number()
        .nullable()
        .transform(utils.emptyStringToNullTransform)
        .integer('Ce champ doit contenir un nombre entier')
        .moreThan(0, 'Doit être supérieur à 0'),
    max_participants_type: yup.string().nullable(),
    max_participants_texte: yup.string().nullable(),
    max_participants_visible: yup.boolean().default(false).transform(utils.nullBoolToFalse),
    signer_contrat: yup.boolean().nullable().default(false).transform(utils.nullBoolToFalse),
    ficav: yup.boolean().nullable().default(false).transform(utils.nullBoolToFalse),
    fk_id_contact_par_defaut: yup.number().nullable(),
    fk_id_lieu: yup.number().nullable(),
    priorite: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    guide_type_accueil: yup.string().nullable(),
    guide_creation_horaire: yup.string().nullable(),
    guide_minimum_facturable_jour_anim_client: yup.string().nullable(),
    guide_minimum_facturable_jour_anim_fournisseur: yup.string().nullable(),
    guide_changement_prix: yup.string().nullable(),
    guide_FAQ: yup.string().nullable(),
    guide_preparation: yup.string().nullable(),
    guide_clauses_politiques: yup.string().nullable(),
    minimum_facturable: yup.string().nullable(),
    vitrine_maximum_participants: yup.string().nullable(),
    horaire_type: yup.string().nullable(),
    questionnaire_logistique: yup.string().nullable(),
    public_date_echeance: utils.toStringSchema(
        yup
            .date()
            .min(new Date(Date.now() - 86400000), "La date d'échéance ne peut être antérieure à celle d'aujourd'hui")
            .nullable()
            .transform(utils.emptyStringToNullTransform),
    ),
    fk_methode_paiement: yup.number().nullable(),
    nom_acces_d: yup.string().nullable(),
}) as yup.ObjectSchema<Partial<Activite>>;
